import moment from "moment";
import { ValueOrDots } from "../../../components/exportWord/partials";
import { formatDateTable } from "../../../utils/functionUtils";

const TemplateBaoCaoTongHop = (props: any) => {
  const { data } = props;

  const canBoDaoTaoTren12Tiet = data?.listNhanVien?.filter((item: any) => item.soTiet > 12).length;

  return (
    <div className="word spaces px-70 colors-word">
      <div className="spaces text-center flex flex-between">
        <div>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.listNhanVien[0]?.departmentOfHealth || ""} size={70} />
            </span>
          </p>
          <p className="fw-600">
            <span className="spaces text-uppercase ml-5">
              <ValueOrDots className="" value={data?.listNhanVien[0]?.orgHeader || ""} size={70} />
            </span>
          </p>
        </div>
        <div></div>
      </div>
      <div className="text-center">
        <p className="text-uppercase fw-600">BẢNG TỔNG HỢP THEO DÕI ĐÀO TẠO LIÊN TỤC CỦA TOÀN BỆNH VIỆN</p>
        <p className="text-uppercase fw-600">
          năm <ValueOrDots size={10} value={moment().format("YYYY") || ""} />
        </p>
      </div>
      <div className="spaces">
        <p className="text-uppercase fw-600">
          Tổng số cán bộ: <ValueOrDots value={data?.listNhanVien.length || 0} size={10} />
        </p>
        <p className="text-uppercase fw-600">
          TỔNG SỐ CÁN BỘ ĐƯỢC ĐÀO TẠO LIÊN TỤC TRÊN 12 TIẾT: <ValueOrDots value={canBoDaoTaoTren12Tiet || "0"} size={10} />
        </p>
      </div>

      <div className="spaces mt-16 mb-100">
        <table className="table-auto border border-collapse border-gray-600 w-100 text-center">
          <thead>
            <tr>
              <th className="border border-gray-600 fs-6 px-2">STT</th>
              <th className="border border-gray-600 fs-6 px-2">HỌ VÀ TÊN</th>
              <th className="border border-gray-600 fs-6 px-2" style={{ width: "100px" }}>NGÀY THÁNG NĂM SINH</th>
              <th className="border border-gray-600 fs-6 px-2">TRÌNH ĐỘ CHUYÊN MÔN</th>
              <th className="border border-gray-600 fs-6 px-2">KHOA PHÒNG LÀM VIỆC</th>
              <th className="border border-gray-600 fs-6 px-2">NỘI DUNG KHÓA HỌC</th>
              <th className="border border-gray-600 fs-6 px-2">NƠI ĐÀO TẠO</th>
              <th className="border border-gray-600 fs-6 px-2">THỜI GIAN HỌC</th>
              <th className="border border-gray-600 fs-6 px-2" style={{ width: "100px" }}>TỔNG SỐ TIẾT QUY ĐỔI</th>
            </tr>
          </thead>
          <tbody>
            {data?.listNhanVien.map((row: any, index: number) => (
              <tr key={row?.id}>
                <td className="border border-gray-600 fs-6 px-2">{index + 1}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.tenNhanVien ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.birthDate ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.chucDanhText ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.phongBanText ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.tenKhoaDaoTao ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{row?.noiDaoTao ?? ""}</td>
                <td className="border border-gray-600 text-left fs-6 px-2">{formatDateTable(row?.hieuLucTuNgay)} {row?.hieuLucDenNgay && " - "}{formatDateTable(row?.hieuLucDenNgay)}</td>
                <td className="border border-gray-600 text-right fs-6 px-2">{row?.soTiet || 0}</td>
              </tr>
            ))}
            {[...Array(2)].map((_, i) => (
              <tr key={i}>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
                <td className="border border-gray-600">&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TemplateBaoCaoTongHop;